import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { gallery } from "@/mocks/gossip";

export default function GallerySection() {
  return (
    <section id="gallery" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          index="04"
          title="瓜田合集"
          subtitle="经网友整理与投稿的封面合集。聊天截图考古、评论区金句、现场直击，一次逛完不用来回翻帖。"
          meta="合集持续收录中"
        />

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-12 lg:grid-cols-4">
          {gallery.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 80} className="h-full">
              <a
                href="#discuss"
                className="group relative block h-56 w-full cursor-pointer overflow-hidden rounded-lg bg-background-950 md:h-64"
              >
                <img
                  src={item.cover}
                  alt={`${item.title} 合集封面`}
                  title={`${item.title} 骚女qq 瓜田合集`}
                  className="h-full w-full object-cover object-top opacity-90 transition-transform duration-700 group-hover:scale-110"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
                <span className="absolute left-4 top-4 rounded-md bg-background-50/95 px-2.5 py-1 text-[11px] font-bold text-secondary-800">
                  {item.tag}
                </span>
                <div className="absolute inset-x-4 bottom-4">
                  <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1.5 text-[11px] text-background-100/90">
                      <i className="ri-eye-line" />
                      {item.views} 浏览
                    </span>
                    <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-accent-300 transition-transform group-hover:translate-x-0.5">
                      查看合集
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-4 rounded-lg border border-dashed border-secondary-300 bg-background-50 p-5 md:flex-row md:items-center md:p-6">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-inbox-archive-line text-xl" />
            </span>
            <div>
              <p className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                手里还有没被收录的瓜？
              </p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">
                欢迎投稿线索与整理好的合集，我们会择优补进瓜田档案。
              </p>
            </div>
          </div>
          <a
            href="#subscribe"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-secondary-400 bg-background-50 px-5 py-2.5 text-sm font-semibold text-secondary-800 transition-colors hover:bg-secondary-100"
          >
            <i className="ri-add-line" />
            我要投稿
          </a>
        </div>
      </div>
    </section>
  );
}